import React, { useEffect, useState, useRef, useContext } from 'react';
import { Redirect, useHistory } from 'react-router-dom';
import { URLBunge, URLBungeAvatar } from "./Componentes/Config";
import { LogAcesso, ReactHtmlParser } from "./Componentes/Funcoes";
import CabecalhoPagina from "./Componentes/Cabecalho";
import Carregando from "./Componentes/Carregando";
import MenuPrinc from "./Componentes/MenuPrinc";
import Avatar from 'avataaars'

import {
  Clear,
  BackgroundImg,
  TitNoticias,
  ColunaPerfilAvatar,
  BtGravarAlteracoes,
  DivListaAvatar,
  NomeTipoAvatar,
  BtOpcaoAvatar,
  TextCarregando,
  BtVoltar
} from './Estilos'


import ImgBtSetaVoltar from "./Images/BtSeta.png";


function PerfilAvatar(props) {

  const history = useHistory();
  const [ Loading, setLoading ] = useState(true);

  const [ NomeEvento, setNomeEvento ] = useState("Minha Bunge Vendas");
  const [ Token, setToken ] = useState(localStorage.getItem("c_token"));

  useEffect(() => {
    if (Token === null) {
        history.push({ pathname: '/', state: {} });
    } else {
        LogAcesso(Token, "Perfil Avatar")
    }
  }, []);


  useEffect(() => {
    PegaAvatars()
  },[]);



  const Bt_skinColor = (props) => {
    var BgSelecionado = '#DDD';
    if(skinColor == props.produto) {
      BgSelecionado = '#043c54';
    }
    return <>
      <BtOpcaoAvatar BgItem={BgSelecionado} onClick={()=>{
        set_skinColor(props.produto);
        setId_skinColor(props.produtoId);
      }}
      >
        {/* {skinColor} */}
        <Avatar
              style = {{width: '70px', height: '70px'}}
              avatarStyle = 'Circle'
              topType = {'.'}
              accessoriesType = {'.'}
              hatColor = {'.'}
              hairColor = {'.'}
              facialHairType = {'.'}
              facialHairColor = {'.'}
              clotheType = {'.'}
              clotheColor = {'.'}
              graphicType = {'.'}
              eyeType = {'.'}
              eyebrowType = {'.'}
              mouthType = {'.'}
              skinColor = {props.produto}
          />
      </BtOpcaoAvatar>
    </>
  }

  const Bt_topType = (props) => {
    var BgSelecionado = '#DDD';
    if(topType == props.produto) {
      BgSelecionado = '#043c54';
    }
    return <>
      <BtOpcaoAvatar BgItem={BgSelecionado} onClick={()=>{ set_topType(props.produto); setId_topType(props.produtoId); }} >
          <Avatar
            style = {{width: '70px', height: '70px'}}
            avatarStyle = 'Circle'
            topType = {props.produto}
            accessoriesType = {'.'}
            hatColor = {'.'}
            hairColor = {'.'}
            facialHairType = {'.'}
            facialHairColor = {'.'}
            clotheType = {'.'}
            clotheColor = {'.'}
            graphicType = {'.'}
            eyeType = {'.'}
            eyebrowType = {'.'}
            mouthType = {'.'}
            skinColor = {'.'}
          />
      </BtOpcaoAvatar>
    </>
  }

  const Bt_hatColor = (props) => {
    var BgSelecionado = '#DDD';
    if(hatColor == props.produto) {
      BgSelecionado = '#043c54';
    }
    var CorChapeu = '';  
    switch (props.produto) {
      case 'Black':
        CorChapeu = '#262E33'; break;
      case 'Blue01':
        CorChapeu = '#65C9FF'; break;
      case 'Blue02':
        CorChapeu = '#5199E4'; break;
      case 'Blue03':
        CorChapeu = '#25557C'; break;
      case 'Gray01':
        CorChapeu = '#E6E6E6'; break;
      case 'Gray02':
        CorChapeu = '#929598'; break;
      case 'Heather':
        CorChapeu = '#3C4F5C'; break;
      case 'PastelBlue':
        CorChapeu = '#B1E2FF'; break;
      case 'PastelGreen':
        CorChapeu = '#A7FFC4'; break;
      case 'PastelOrange':
        CorChapeu = '#FFDEB5'; break;
      case 'PastelRed':
        CorChapeu = '#FFAFB9'; break;
      case 'PastelYellow':
        CorChapeu = '#FFFFB1'; break;
      case 'Pink':
        CorChapeu = '#FF488E'; break;
      case 'Red':
        CorChapeu = '#FF5C5C'; break;
      case 'White':
        CorChapeu = '#FFFFFF'; break;
    }
    return <>
      <BtOpcaoAvatar BgItem={BgSelecionado} onClick={()=>{ set_hatColor(props.produto); setId_hatColor(props.produtoId); }} >
        <div style={{ backgroundColor: CorChapeu, width: 40, height: 40, borderRadius: 4, margin: 3 }}></div>
      </BtOpcaoAvatar>
    </>
  }

  const Bt_hairColor = (props) => {
    var BgSelecionado = '#DDD';
    if(hairColor == props.produto) {
      BgSelecionado = '#043c54';
    }

    var CorCabelo = '';  
    switch (props.produto) {
      case 'Auburn':
        CorCabelo = '#A55728'; break;
      case 'Black':
        CorCabelo = '#2C1B18'; break;
      case 'Blonde':
        CorCabelo = '#B58143'; break;
      case 'BlondeGolden':
        CorCabelo = '#D6B370'; break;
      case 'Brown':
        CorCabelo = '#724133'; break;
      case 'BrownDark':
        CorCabelo = '#4A312C'; break;
      case 'PastelPink':
        CorCabelo = '#F59797'; break;
      case 'Platinum':
        CorCabelo = '#ECDCBF'; break;
      case 'Red':
        CorCabelo = '#C93305'; break;
      case 'SilverGray':
        CorCabelo = '#E8E1E1'; break;
    }
    return <>
    <BtOpcaoAvatar BgItem={BgSelecionado} onClick={()=>{ set_hairColor(props.produto); setId_hairColor(props.produtoId); }} >
      <div style={{ backgroundColor: CorCabelo, width: 40, height: 40, borderRadius: 4, margin: 3 }}></div>
    </BtOpcaoAvatar>
    </>
  }

  const Bt_facialHairColor = (props) => {
    var BgSelecionado = '#DDD';
    if(facialHairColor == props.produto) {
      BgSelecionado = '#043c54';
    }
    var CorBarba = '';
    switch (props.produto) {
      case 'Auburn':
        CorBarba = '#A55728'; break;
      case 'Black':
        CorBarba = '#2C1B18'; break;
      case 'Blonde':
        CorBarba = '#B58143'; break;
      case 'BlondeGolden':
        CorBarba = '#D6B370'; break;
      case 'Brown':
        CorBarba = '#724133'; break;
      case 'BrownDark':
        CorBarba = '#4A312C'; break;
      case 'Platinum':
        CorBarba = '#ECDCBF'; break;
      case 'Red':
        CorBarba = '#C93305'; break;
    }
    return <>
    <BtOpcaoAvatar BgItem={BgSelecionado} onClick={()=>{ set_facialHairColor(props.produto); setId_facialHairColor(props.produtoId); }} >
      <div style={{ backgroundColor: CorBarba, width: 40, height: 40, borderRadius: 4, margin: 3 }}></div>
    </BtOpcaoAvatar>
    </>
  }

  const Bt_clotheColor = (props) => {
    var BgSelecionado = '#DDD';
    if(clotheColor == props.produto) {
      BgSelecionado = '#043c54';
    }
    var CorRoupa = '';  
    switch (props.produto) {
      case 'Black':
        CorRoupa = '#262E33'; break;
      case 'Blue01':
        CorRoupa = '#65C9FF'; break;
      case 'Blue02':
        CorRoupa = '#5199E4'; break;
      case 'Blue03':
        CorRoupa = '#25557C'; break;
      case 'Gray01':
        CorRoupa = '#E6E6E6'; break;
      case 'Gray02':
        CorRoupa = '#929598'; break;
      case 'Heather':
        CorRoupa = '#3C4F5C'; break;
      case 'PastelBlue':
        CorRoupa = '#B1E2FF'; break;
      case 'PastelGreen':
        CorRoupa = '#A7FFC4'; break;
      case 'PastelOrange':
        CorRoupa = '#FFDEB5'; break;
      case 'PastelRed':
        CorRoupa = '#FFAFB9'; break;
      case 'PastelYellow':
        CorRoupa = '#FFFFB1'; break;
      case 'Pink':
        CorRoupa = '#FF488E'; break;
      case 'Red':
        CorRoupa = '#FF5C5C'; break;
      case 'White':
        CorRoupa = '#FFFFFF'; break;
    }  
    return <>
    <BtOpcaoAvatar BgItem={BgSelecionado} onClick={()=>{ set_clotheColor(props.produto); setId_clotheColor(props.produtoId); }} >
      <div style={{ backgroundColor: CorRoupa, width: 40, height: 40, borderRadius: 4, margin: 3 }}></div>
    </BtOpcaoAvatar>
    </>
  }

  const Bt_facialHairType = (props) => {
    var BgSelecionado = '#DDD';
    if(facialHairType == props.produto) {
      BgSelecionado = '#043c54';
    }
    return <>
      <BtOpcaoAvatar BgItem={BgSelecionado} onClick={()=>{ set_facialHairType(props.produto); setId_facialHairType(props.produtoId); }} >
          <Avatar
            style = {{width: '70px', height: '70px'}}
            avatarStyle = 'Circle'
            topType = {'NoHair'}
            accessoriesType = {'.'}
            hatColor = {'.'}
            hairColor = {'.'}
            facialHairType = {props.produto}
            facialHairColor = {'.'}
            clotheType = {'.'}
            clotheColor = {'.'}
            graphicType = {'.'}
            eyeType = {'.'}
            eyebrowType = {'.'}
            mouthType = {'.'}
            skinColor = {'.'}
          />
      </BtOpcaoAvatar>
    </>
  }

  const Bt_accessoriesType = (props) => {
    var BgSelecionado = '#DDD';
    if(accessoriesType == props.produto) {
      BgSelecionado = '#043c54';
    }
    return <>
      <BtOpcaoAvatar BgItem={BgSelecionado} onClick={()=>{ set_accessoriesType(props.produto); setId_accessoriesType(props.produtoId); }} >
          <Avatar
            style = {{width: '70px', height: '70px'}}
            avatarStyle = 'Circle'
            topType = {'NoHair'}
            accessoriesType = {props.produto}
            hatColor = {'.'}
            hairColor = {'.'}
            facialHairType = {'.'}
            facialHairColor = {'.'}
            clotheType = {'.'}
            clotheColor = {'.'}
            graphicType = {'.'}
            eyeType = {'.'}
            eyebrowType = {'.'}
            mouthType = {'.'}
            skinColor = {'.'}
          />
      </BtOpcaoAvatar>
    </>
  }

  const Bt_clotheType = (props) => {
    var BgSelecionado = '#DDD';
    if(clotheType == props.produto) {
      BgSelecionado = '#043c54';
    }
    return <>
      <BtOpcaoAvatar BgItem={BgSelecionado} onClick={()=>{ set_clotheType(props.produto); setId_clotheType(props.produtoId); }} >
          <Avatar
            style = {{width: '70px', height: '70px'}}
            avatarStyle = 'Circle'
            topType = {'NoHair'}
            accessoriesType = {'.'}
            hatColor = {'.'}
            hairColor = {'.'}
            facialHairType = {'.'}
            facialHairColor = {'.'}
            clotheType = {props.produto}
            clotheColor = {'.'}
            graphicType = {'.'}
            eyeType = {'.'}
            eyebrowType = {'.'}
            mouthType = {'.'}
            skinColor = {'.'}
          />
      </BtOpcaoAvatar>
    </>
  }

  const Bt_eyeType = (props) => {
    var BgSelecionado = '#DDD';
    if(eyeType == props.produto) {
      BgSelecionado = '#043c54';
    }
    return <>
      <BtOpcaoAvatar BgItem={BgSelecionado} onClick={()=>{ set_eyeType(props.produto); setId_eyeType(props.produtoId); }} >
          <Avatar
            style = {{width: '70px', height: '70px'}}
            avatarStyle = 'Circle'
            topType = {'NoHair'}
            accessoriesType = {'.'}
            hatColor = {'.'}
            hairColor = {'.'}
            facialHairType = {'.'}
            facialHairColor = {'.'}
            clotheType = {'.'}
            clotheColor = {'.'}
            graphicType = {'.'}
            eyeType = {props.produto}
            eyebrowType = {'.'}
            mouthType = {'.'}
            skinColor = {'.'}
          />
      </BtOpcaoAvatar>
    </>
  }

  const Bt_eyebrowType = (props) => {
    var BgSelecionado = '#DDD';
    if(eyebrowType == props.produto) {
      BgSelecionado = '#043c54';
    }
    return <>
      <BtOpcaoAvatar BgItem={BgSelecionado} onClick={()=>{ set_eyebrowType(props.produto); setId_eyebrowType(props.produtoId); }} >
          <Avatar
            style = {{width: '70px', height: '70px'}}
            avatarStyle = 'Circle'
            topType = {'NoHair'}
            accessoriesType = {'.'}
            hatColor = {'.'}
            hairColor = {'.'}
            facialHairType = {'.'}
            facialHairColor = {'.'}
            clotheType = {'.'}
            clotheColor = {'.'}
            graphicType = {'.'}
            eyeType = {'.'}
            eyebrowType = {props.produto}
            mouthType = {'.'}
            skinColor = {'.'}
          />
      </BtOpcaoAvatar>
    </>
  }

  const Bt_mouthType = (props) => {
    var BgSelecionado = '#DDD';
    if(mouthType == props.produto) {
      BgSelecionado = '#043c54';
    }
    return <>
      <BtOpcaoAvatar BgItem={BgSelecionado} onClick={()=>{ set_mouthType(props.produto); setId_mouthType(props.produtoId); }} >
          <Avatar
            style = {{width: '70px', height: '70px'}}
            avatarStyle = 'Circle'
            topType = {'NoHair'}
            accessoriesType = {'.'}
            hatColor = {'.'}
            hairColor = {'.'}
            facialHairType = {'.'}
            facialHairColor = {'.'}
            clotheType = {'.'}
            clotheColor = {'.'}
            graphicType = {'.'}
            eyeType = {'.'}
            eyebrowType = {'.'}
            mouthType = {props.produto}
            skinColor = {'.'}
          />
      </BtOpcaoAvatar>
    </>
  }

  async function PegaAvatars() {
    
    var myHeaders = new Headers();
    myHeaders.append("Authorization", "bearer " + Token);

    var requestOptions = {
      method: 'GET',
      headers: myHeaders,
      redirect: 'follow'
    };
    
    fetch(`${URLBunge}/api/Avatar/ListaConquistado`, requestOptions)
      .then(response => response.json())
      .then(result => {
        console.log(result);
        for(var prop in result.avatarConquistado) {
          // console.log('passou', prop);
          if(result.avatarConquistado[prop].categoria === "topType") {
            var Conteudo = {
              "produtoId": result.avatarConquistado[prop].produtoId,
              "categoria": result.avatarConquistado[prop].categoria,
              "produto": result.avatarConquistado[prop].produto
            }
            setItems_topType(Items_topType => [...Items_topType, Conteudo])
          }
          if(result.avatarConquistado[prop].categoria === "accessoriesType") {
            var Conteudo = {
              "produtoId": result.avatarConquistado[prop].produtoId,
              "categoria": result.avatarConquistado[prop].categoria,
              "produto": result.avatarConquistado[prop].produto
            }
            setItems_accessoriesType(Items_accessoriesType => [...Items_accessoriesType, Conteudo])
          }
          if(result.avatarConquistado[prop].categoria === "hatColor") {
            var Conteudo = {
              "produtoId": result.avatarConquistado[prop].produtoId,
              "categoria": result.avatarConquistado[prop].categoria,
              "produto": result.avatarConquistado[prop].produto
            }
            setItems_hatColor(Items_hatColor => [...Items_hatColor, Conteudo])
          }
          if(result.avatarConquistado[prop].categoria === "hairColor") {
            var Conteudo = {
              "produtoId": result.avatarConquistado[prop].produtoId,
              "categoria": result.avatarConquistado[prop].categoria,
              "produto": result.avatarConquistado[prop].produto
            }
            setItems_hairColor(Items_hairColor => [...Items_hairColor, Conteudo])
          }
          if(result.avatarConquistado[prop].categoria === "facialHairType") {
            var Conteudo = {
              "produtoId": result.avatarConquistado[prop].produtoId,
              "categoria": result.avatarConquistado[prop].categoria,
              "produto": result.avatarConquistado[prop].produto
            }
            setItems_facialHairType(Items_facialHairType => [...Items_facialHairType, Conteudo])
          }
          if(result.avatarConquistado[prop].categoria === "facialHairColor") {
            var Conteudo = {
              "produtoId": result.avatarConquistado[prop].produtoId,
              "categoria": result.avatarConquistado[prop].categoria,
              "produto": result.avatarConquistado[prop].produto
            }
            setItems_facialHairColor(Items_facialHairColor => [...Items_facialHairColor, Conteudo])
          }
          if(result.avatarConquistado[prop].categoria === "clotheType") {
            var Conteudo = {
              "produtoId": result.avatarConquistado[prop].produtoId,
              "categoria": result.avatarConquistado[prop].categoria,
              "produto": result.avatarConquistado[prop].produto
            }
            setItems_clotheType(Items_clotheType => [...Items_clotheType, Conteudo])
          }
          if(result.avatarConquistado[prop].categoria === "clotheColor") {
            var Conteudo = {
              "produtoId": result.avatarConquistado[prop].produtoId,
              "categoria": result.avatarConquistado[prop].categoria,
              "produto": result.avatarConquistado[prop].produto
            }
            setItems_clotheColor(Items_clotheColor => [...Items_clotheColor, Conteudo])
          }
          if(result.avatarConquistado[prop].categoria === "graphicType") {
            var Conteudo = {
              "produtoId": result.avatarConquistado[prop].produtoId,
              "categoria": result.avatarConquistado[prop].categoria,
              "produto": result.avatarConquistado[prop].produto
            }
            setItems_graphicType(Items_graphicType => [...Items_graphicType, Conteudo])
          }
          if(result.avatarConquistado[prop].categoria === "eyeType") {
            var Conteudo = {
              "produtoId": result.avatarConquistado[prop].produtoId,
              "categoria": result.avatarConquistado[prop].categoria,
              "produto": result.avatarConquistado[prop].produto
            }
            setItems_eyeType(Items_eyeType => [...Items_eyeType, Conteudo])
          }
          if(result.avatarConquistado[prop].categoria === "eyebrowType") {
            var Conteudo = {
              "produtoId": result.avatarConquistado[prop].produtoId,
              "categoria": result.avatarConquistado[prop].categoria,
              "produto": result.avatarConquistado[prop].produto
            }
            setItems_eyebrowType(Items_eyebrowType => [...Items_eyebrowType, Conteudo])
          }
          if(result.avatarConquistado[prop].categoria === "mouthType") {
            var Conteudo = {
              "produtoId": result.avatarConquistado[prop].produtoId,
              "categoria": result.avatarConquistado[prop].categoria,
              "produto": result.avatarConquistado[prop].produto
            }
            setItems_mouthType(Items_mouthType => [...Items_mouthType, Conteudo])
          }
          if(result.avatarConquistado[prop].categoria === "skinColor") {
            var Conteudo = {
              "produtoId": result.avatarConquistado[prop].produtoId,
              "categoria": result.avatarConquistado[prop].categoria,
              "produto": result.avatarConquistado[prop].produto
            }
            setItems_skinColor(Items_skinColor => [...Items_skinColor, Conteudo])
          }          
        }
      })
      .catch(error => console.log('error', error));
    
  }


    

  const [Avatar_topType, setAvatar_topType] = useState(localStorage.getItem("c_avatar_topType"));
  const [Avatar_accessoriesType, setAvatar_accessoriesType] = useState(localStorage.getItem("c_avatar_accessoriesType"));
  const [Avatar_hatColor, setAvatar_hatColor] = useState(localStorage.getItem("c_avatar_hatColor"));
  const [Avatar_hairColor, setAvatar_hairColor] = useState(localStorage.getItem("c_avatar_hairColor"));
  const [Avatar_facialHairType, setAvatar_facialHairType] = useState(localStorage.getItem("c_avatar_facialHairType"));
  const [Avatar_facialHairColor, setAvatar_facialHairColor] = useState(localStorage.getItem("c_avatar_facialHairColor"));
  const [Avatar_clotheType, setAvatar_clotheType] = useState(localStorage.getItem("c_avatar_clotheType"));
  const [Avatar_clotheColor, setAvatar_clotheColor] = useState(localStorage.getItem("c_avatar_clotheColor"));
  const [Avatar_graphicType, setAvatar_graphicType] = useState(localStorage.getItem("c_avatar_graphicType"));
  const [Avatar_eyeType, setAvatar_eyeType] = useState(localStorage.getItem("c_avatar_eyeType"));
  const [Avatar_eyebrowType, setAvatar_eyebrowType] = useState(localStorage.getItem("c_avatar_eyebrowType"));
  const [Avatar_mouthType, setAvatar_mouthType] = useState(localStorage.getItem("c_avatar_mouthType"));
  const [Avatar_skinColor, setAvatar_skinColor] = useState(localStorage.getItem("c_avatar_skinColor"));

  const [Id_Avatar_topType, setId_Avatar_topType] = useState(localStorage.getItem("id_avatar_topType"));
  const [Id_Avatar_accessoriesType, setId_Avatar_accessoriesType] = useState(localStorage.getItem("id_avatar_accessoriesType"));
  const [Id_Avatar_hatColor, setId_Avatar_hatColor] = useState(localStorage.getItem("id_avatar_hatColor"));
  const [Id_Avatar_hairColor, setId_Avatar_hairColor] = useState(localStorage.getItem("id_avatar_hairColor"));
  const [Id_Avatar_facialHairType, setId_Avatar_facialHairType] = useState(localStorage.getItem("id_avatar_facialHairType"));
  const [Id_Avatar_facialHairColor, setId_Avatar_facialHairColor] = useState(localStorage.getItem("id_avatar_facialHairColor"));
  const [Id_Avatar_clotheType, setId_Avatar_clotheType] = useState(localStorage.getItem("id_avatar_clotheType"));
  const [Id_Avatar_clotheColor, setId_Avatar_clotheColor] = useState(localStorage.getItem("id_avatar_clotheColor"));
  const [Id_Avatar_graphicType, setId_Avatar_graphicType] = useState(localStorage.getItem("id_avatar_graphicType"));
  const [Id_Avatar_eyeType, setId_Avatar_eyeType] = useState(localStorage.getItem("id_avatar_eyeType"));
  const [Id_Avatar_eyebrowType, setId_Avatar_eyebrowType] = useState(localStorage.getItem("id_avatar_eyebrowType"));
  const [Id_Avatar_mouthType, setId_Avatar_mouthType] = useState(localStorage.getItem("id_avatar_mouthType"));
  const [Id_Avatar_skinColor, setId_Avatar_skinColor] = useState(localStorage.getItem("id_avatar_skinColor"));

  const [Items_topType, setItems_topType] = useState([]);
  const [Items_accessoriesType, setItems_accessoriesType] = useState([]);
  const [Items_hatColor, setItems_hatColor] = useState([]);
  const [Items_hairColor, setItems_hairColor] = useState([]);
  const [Items_facialHairType, setItems_facialHairType] = useState([]);
  const [Items_facialHairColor, setItems_facialHairColor] = useState([]);
  const [Items_clotheType, setItems_clotheType] = useState([]);
  const [Items_clotheColor, setItems_clotheColor] = useState([]);
  const [Items_graphicType, setItems_graphicType] = useState([]);
  const [Items_eyeType, setItems_eyeType] = useState([]);
  const [Items_eyebrowType, setItems_eyebrowType] = useState([]);
  const [Items_mouthType, setItems_mouthType] = useState([]);
  const [Items_skinColor, setItems_skinColor] = useState([]);

  useEffect(() => {    
    set_topType(localStorage.getItem("c_avatar_topType"));
    set_accessoriesType(localStorage.getItem("c_avatar_accessoriesType"));
    set_hatColor(localStorage.getItem("c_avatar_hatColor"));
    set_hairColor(localStorage.getItem("c_avatar_hairColor"));
    set_facialHairType(localStorage.getItem("c_avatar_facialHairType"));
    set_facialHairColor(localStorage.getItem("c_avatar_facialHairColor"));
    set_clotheType(localStorage.getItem("c_avatar_clotheType"));
    set_clotheColor(localStorage.getItem("c_avatar_clotheColor"));
    set_graphicType(localStorage.getItem("c_avatar_graphicType"));
    set_eyeType(localStorage.getItem("c_avatar_eyeType"));
    set_eyebrowType(localStorage.getItem("c_avatar_eyebrowType"));
    set_mouthType(localStorage.getItem("c_avatar_mouthType"));
    set_skinColor(localStorage.getItem("c_avatar_skinColor"));

    setId_topType(localStorage.getItem("id_avatar_topType"));
    setId_accessoriesType(localStorage.getItem("id_avatar_accessoriesType"));
    setId_hatColor(localStorage.getItem("id_avatar_hatColor"));
    setId_hairColor(localStorage.getItem("id_avatar_hairColor"));
    setId_facialHairType(localStorage.getItem("id_avatar_facialHairType"));
    setId_facialHairColor(localStorage.getItem("id_avatar_facialHairColor"));
    setId_clotheType(localStorage.getItem("id_avatar_clotheType"));
    setId_clotheColor(localStorage.getItem("id_avatar_clotheColor"));
    setId_graphicType(localStorage.getItem("id_avatar_graphicType"));
    setId_eyeType(localStorage.getItem("id_avatar_eyeType"));
    setId_eyebrowType(localStorage.getItem("id_avatar_eyebrowType"));
    setId_mouthType(localStorage.getItem("id_avatar_mouthType"));
    setId_skinColor(localStorage.getItem("id_avatar_skinColor"));

  },[]);





  const [ topType, set_topType ] = useState('');
  const [ accessoriesType, set_accessoriesType ] = useState('');
  const [ hatColor, set_hatColor ] = useState('');
  const [ hairColor, set_hairColor ] = useState('');
  const [ facialHairType, set_facialHairType ] = useState('');
  const [ facialHairColor, set_facialHairColor ] = useState('');
  const [ clotheType, set_clotheType ] = useState('');
  const [ clotheColor, set_clotheColor ] = useState('');
  const [ graphicType, set_graphicType ] = useState('');
  const [ eyeType, set_eyeType ] = useState('');
  const [ eyebrowType, set_eyebrowType ] = useState('');
  const [ mouthType, set_mouthType ] = useState('');
  const [ skinColor, set_skinColor ] = useState('');


  const [Id_topType, setId_topType] = useState('');
  const [Id_accessoriesType, setId_accessoriesType] = useState('');
  const [Id_hatColor, setId_hatColor] = useState('');
  const [Id_hairColor, setId_hairColor] = useState('');
  const [Id_facialHairType, setId_facialHairType] = useState('');
  const [Id_facialHairColor, setId_facialHairColor] = useState('');
  const [Id_clotheType, setId_clotheType] = useState('');
  const [Id_clotheColor, setId_clotheColor] = useState('');
  const [Id_graphicType, setId_graphicType] = useState('');
  const [Id_eyeType, setId_eyeType] = useState('');
  const [Id_eyebrowType, setId_eyebrowType] = useState('');
  const [Id_mouthType, setId_mouthType] = useState('');
  const [Id_skinColor, setId_skinColor] = useState('');


  const [ Mostra_hatColor, setMostra_hatColor ] = useState(false);
  useEffect(() => {
    switch (topType) {
      case 'Turban':
        setMostra_hatColor(true); break;
      case 'WinterHat1':
        setMostra_hatColor(true); break;
      case 'WinterHat2':
        setMostra_hatColor(true); break;
      case 'WinterHat3':
        setMostra_hatColor(true); break;
      case 'WinterHat4':
        setMostra_hatColor(true); break;
      default:
        setMostra_hatColor(false);
    }
  },[topType]);

  const [ Mostra_hairColor, setMostra_hairColor ] = useState(false);
  useEffect(() => {
    switch (topType) {
      case "LongHairBigHair": setMostra_hairColor(true); break;
      case "LongHairBob": setMostra_hairColor(true); break;
      case "LongHairBun": setMostra_hairColor(true); break;
      case "LongHairCurly": setMostra_hairColor(true); break;
      case "LongHairCurvy": setMostra_hairColor(true); break;
      case "LongHairDreads": setMostra_hairColor(true); break;
      case "LongHairFro": setMostra_hairColor(true); break;
      case "LongHairFroBand": setMostra_hairColor(true); break;
      case "LongHairNotTooLong": setMostra_hairColor(true); break;
      case "LongHairShavedSides": setMostra_hairColor(true); break;
      case "LongHairMiaWallace": setMostra_hairColor(true); break;
      case "LongHairStraight": setMostra_hairColor(true); break;
      case "LongHairStraight2": setMostra_hairColor(true); break;
      case "LongHairStraightStrand": setMostra_hairColor(true); break;
      case "ShortHairDreads01": setMostra_hairColor(true); break;
      case "ShortHairDreads02": setMostra_hairColor(true); break;
      case "ShortHairFrizzle": setMostra_hairColor(true); break;
      case "ShortHairShaggyMullet": setMostra_hairColor(true); break;
      case "ShortHairShortCurly": setMostra_hairColor(true); break;
      case "ShortHairShortFlat": setMostra_hairColor(true); break;
      case "ShortHairShortRound": setMostra_hairColor(true); break;
      case "ShortHairShortWaved": setMostra_hairColor(true); break;
      case "ShortHairSides": setMostra_hairColor(true); break;
      case "ShortHairTheCaesar": setMostra_hairColor(true); break;
      case "ShortHairTheCaesarSidePart": setMostra_hairColor(true); break;
      default:
        setMostra_hairColor(false);
    }
  },[topType]);



  const [ Mostra_facialHairColor, setMostra_facialHairColor ] = useState(false);
  useEffect(() => {
    switch (facialHairType) {
      case "BeardMedium": setMostra_facialHairColor(true); break;
      case "BeardLight": setMostra_facialHairColor(true); break;
      case "BeardMajestic": setMostra_facialHairColor(true); break;
      case "MoustacheFancy": setMostra_facialHairColor(true); break;
      case "MoustacheMagnum": setMostra_facialHairColor(true); break;
      default:
        setMostra_facialHairColor(false);
    }
  },[facialHairType]);



  const [ Mostra_clotheColor, setMostra_clotheColor ] = useState(false);
  useEffect(() => {
    switch (clotheType) {
      case "CollarSweater": setMostra_clotheColor(true); break;
      case "GraphicShirt": setMostra_clotheColor(true); break;
      case "Hoodie": setMostra_clotheColor(true); break;
      case "Overall": setMostra_clotheColor(true); break;
      case "ShirtCrewNeck": setMostra_clotheColor(true); break;
      case "ShirtScoopNeck": setMostra_clotheColor(true); break;
      case "ShirtVNeck": setMostra_clotheColor(true); break;
      default:
        setMostra_clotheColor(false);
    }
  },[clotheType]);






  function GravarAlteracoes() {

    localStorage.setItem("c_avatar_topType", topType);
    localStorage.setItem("c_avatar_accessoriesType", accessoriesType);
    localStorage.setItem("c_avatar_hatColor", hatColor);
    localStorage.setItem("c_avatar_hairColor", hairColor);
    localStorage.setItem("c_avatar_facialHairType", facialHairType);
    localStorage.setItem("c_avatar_facialHairColor", facialHairColor);
    localStorage.setItem("c_avatar_clotheType", clotheType);
    localStorage.setItem("c_avatar_clotheColor", clotheColor);
    localStorage.setItem("c_avatar_graphicType", graphicType);
    localStorage.setItem("c_avatar_eyeType", eyeType);
    localStorage.setItem("c_avatar_eyebrowType", eyebrowType);
    localStorage.setItem("c_avatar_mouthType", mouthType);
    localStorage.setItem("c_avatar_skinColor", skinColor);

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "bearer " + Token);
    myHeaders.append("Content-Type", "application/json");

    var raw = JSON.stringify({
      "produtosId": [
        Id_topType,
        Id_accessoriesType,
        Id_hatColor,
        Id_hairColor,
        Id_facialHairType,
        Id_facialHairColor,
        Id_clotheType,
        Id_clotheColor,
        Id_graphicType,
        Id_eyeType,
        Id_eyebrowType,
        Id_mouthType,
        Id_skinColor
      ]
    });

    var requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: raw,
      redirect: 'follow'
    };

    fetch(`${URLBunge}/api/Avatar/Salva`, requestOptions)
      .then(response => response.json())
      .then(result => {
        if(result.sucesso === true) {
          alert("Avatar atualizado");
          // Alert.alert( "Avatar atualizado", "Seu avatar foi atualizado com sucesso.", [ { text: "OK", onPress: () => props.navigation.navigate('Perfil') } ] );          
        } else {
          alert("Avatar não atualizado");
          // Alert.alert( "Avatar não atualizado", "Seu avatar não foi atualizado, tente novamente.", [ { text: "OK" } ] );
        }
      })
      .catch(error => console.log('error', error));

  }

  useEffect(() => { 
    if(Items_skinColor.length > 0) {
      setLoading(false);
    }
  },[Items_skinColor.length]);

  return (
    <>  
        <CabecalhoPagina NomeEvento={NomeEvento} />
        {Loading === true ? <Carregando /> : null }

        <BackgroundImg Background={''} BackgroundMob={''} bgcolor={'#FFFFFF'}>
            
            <ColunaPerfilAvatar>
                <div className={'AreaColunaPerfilAvatar'}>

                    <TitNoticias>Editar Avatar</TitNoticias>
                    <Clear />

                    <BtVoltar onClick={()=>history.push({ pathname: '/Perfil', state: { TipoPesquisa: 2 } })} style={{marginLeft: 'auto', marginRight: 'auto'}}>
                      <img src={ImgBtSetaVoltar} /> <div>VOLTAR</div>
                    </BtVoltar>
                    <br/>
                    <Clear />

                    <Avatar
                      style = {{width: '250px', height: '250px'}}
                      avatarStyle = 'Circle'
                      topType = {topType}
                      accessoriesType = {accessoriesType}
                      hatColor = {hatColor}
                      hairColor = {hairColor}
                      facialHairType = {facialHairType}
                      facialHairColor = {facialHairColor}
                      clotheType = {clotheType}
                      clotheColor = {clotheColor}
                      graphicType = {graphicType}
                      eyeType = {eyeType}
                      eyebrowType = {eyebrowType}
                      mouthType = {mouthType}
                      skinColor = {skinColor}
                    />
                    <Clear />

                    <BtGravarAlteracoes onClick={()=>GravarAlteracoes()}>GRAVAR ALTERAÇÕES</BtGravarAlteracoes>

                    <Clear />
                    <NomeTipoAvatar>COR DA PELE</NomeTipoAvatar>
                    <DivListaAvatar>
                      {
                        Items_skinColor.length > 0 ?
                          Items_skinColor.map((item, index) => {
                            return <>
                              <Bt_skinColor
                                Props={props}
                                produtoId={item.produtoId}
                                categoria={item.categoria}
                                produto={item.produto}
                              />
                            </>
                          })
                        : <></>
                      }
                    </DivListaAvatar>

                    <Clear />
                    <NomeTipoAvatar>CABELO / CHAPÉU / GORRO</NomeTipoAvatar>
                    <DivListaAvatar>
                      {
                        Items_topType.length > 0 ?
                          Items_topType.map((item, index) => {
                            return <>
                              <Bt_topType
                                Props={''}
                                produtoId={item.produtoId}
                                categoria={item.categoria}
                                produto={item.produto}
                              />
                            </>
                          })
                        : <></>
                      }
                    </DivListaAvatar>

                    {Mostra_hatColor === true ?
                    <>
                    <NomeTipoAvatar>COR DO CHAPÉU / GORRO</NomeTipoAvatar>
                    <DivListaAvatar>
                      {
                        Items_hatColor.length > 0 ?
                          Items_hatColor.map((item, index) => {
                            return <>
                              <Bt_hatColor
                                Props={props}
                                produtoId={item.produtoId}
                                categoria={item.categoria}
                                produto={item.produto}
                              />
                            </>
                          })
                        : <></>
                      }
                    </DivListaAvatar>
                    </>
                    : null}

                    {Mostra_hairColor === true ?
                    <>
                    <NomeTipoAvatar>COR DO CABELO</NomeTipoAvatar>
                    <DivListaAvatar>
                      {
                        Items_hairColor.length > 0 ?
                          Items_hairColor.map((item, index) => {
                            return <>
                              <Bt_hairColor
                                Props={props}
                                produtoId={item.produtoId}
                                categoria={item.categoria}
                                produto={item.produto}
                              />
                            </>
                          })
                        : <></>
                      }
                    </DivListaAvatar>
                    </>
                    : null}

                    <NomeTipoAvatar>BARBA / BIGODE</NomeTipoAvatar>
                    <DivListaAvatar>
                      {
                        Items_facialHairType.length > 0 ?
                          Items_facialHairType.map((item, index) => {
                            return <>
                              <Bt_facialHairType
                                Props={props}
                                produtoId={item.produtoId}
                                categoria={item.categoria}
                                produto={item.produto}
                              />
                            </>
                          })
                        : <></>
                      }
                    </DivListaAvatar>

                    {Mostra_facialHairColor === true ?
                    <>
                    <NomeTipoAvatar>COR DA BARBA / BIGODE</NomeTipoAvatar>
                    <DivListaAvatar>
                      {
                        Items_facialHairColor.length > 0 ?
                          Items_facialHairColor.map((item, index) => {
                            return <>
                              <Bt_facialHairColor
                                Props={props}
                                produtoId={item.produtoId}
                                categoria={item.categoria}
                                produto={item.produto}
                              />
                            </>
                          })
                        : <></>
                      }
                    </DivListaAvatar>
                    </>
                    : null}

                    <NomeTipoAvatar>ACESSÓRIOS</NomeTipoAvatar>
                    <DivListaAvatar>
                      {
                        Items_accessoriesType.length > 0 ?
                          Items_accessoriesType.map((item, index) => {
                            return <>
                              <Bt_accessoriesType
                                Props={props}
                                produtoId={item.produtoId}
                                categoria={item.categoria}
                                produto={item.produto}
                              />
                            </>
                          })
                        : <></>
                      }
                    </DivListaAvatar>

                    <NomeTipoAvatar>ROUPA</NomeTipoAvatar>
                    <DivListaAvatar>
                      {
                        Items_clotheType.length > 0 ?
                          Items_clotheType.map((item, index) => {
                            return <>
                              <Bt_clotheType
                                Props={props}
                                produtoId={item.produtoId}
                                categoria={item.categoria}
                                produto={item.produto}
                              />
                            </>
                          })
                        : <></>
                      }
                    </DivListaAvatar>

                    {Mostra_clotheColor === true ?
                    <>
                    <NomeTipoAvatar>COR DA ROUPA</NomeTipoAvatar>
                    <DivListaAvatar>
                      {
                        Items_clotheColor.length > 0 ?
                          Items_clotheColor.map((item, index) => {
                            return <>
                              <Bt_clotheColor
                                Props={props}
                                produtoId={item.produtoId}
                                categoria={item.categoria}
                                produto={item.produto}
                              />
                            </>
                          })
                        : <></>
                      }
                    </DivListaAvatar>
                    </>
                    : null}

                    <NomeTipoAvatar>OLHOS</NomeTipoAvatar>
                    <DivListaAvatar>
                      {
                        Items_eyeType.length > 0 ?
                          Items_eyeType.map((item, index) => {
                            return <>
                              <Bt_eyeType
                                Props={props}
                                produtoId={item.produtoId}
                                categoria={item.categoria}
                                produto={item.produto}
                              />
                            </>
                          })
                        : <></>
                      }
                    </DivListaAvatar>

                    <NomeTipoAvatar>SOBRANCELHA</NomeTipoAvatar>
                    <DivListaAvatar>
                      {
                        Items_eyebrowType.length > 0 ?
                          Items_eyebrowType.map((item, index) => {
                            return <>
                              <Bt_eyebrowType
                                Props={props}
                                produtoId={item.produtoId}
                                categoria={item.categoria}
                                produto={item.produto}
                              />
                            </>
                          })
                        : <></>
                      }
                    </DivListaAvatar>

                    <NomeTipoAvatar>BOCA</NomeTipoAvatar>
                    <DivListaAvatar>
                      {
                        Items_mouthType.length > 0 ?
                          Items_mouthType.map((item, index) => {
                            return <>
                              <Bt_mouthType
                                Props={props}
                                produtoId={item.produtoId}
                                categoria={item.categoria}
                                produto={item.produto}
                              />
                            </>
                          })
                        : <></>
                      }
                    </DivListaAvatar>

                </div>  
            </ColunaPerfilAvatar>
            
            <MenuPrinc Pagina="Pesquisas" />
         </BackgroundImg>
    </>
  );

}

export default PerfilAvatar;
